import { render, staticRenderFns } from "./AddArticles.vue?vue&type=template&id=a5c8f6a6"
import script from "./AddArticles.vue?vue&type=script&lang=ts"
export * from "./AddArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports